module.exports = __webpack_public_path__ + "static/corriere-della-sera-logo-8e23e5c884d1d9f5773eb0a0579c829b.jpg";